import { render, staticRenderFns } from "./PrestationInsurance.vue?vue&type=template&id=2b9273d8&scoped=true"
import script from "./PrestationInsurance.vue?vue&type=script&lang=js"
export * from "./PrestationInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9273d8",
  null
  
)

export default component.exports